import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_PARTY_AND_CADIDATE_NUMBER } from "../Schema/PartiesAndCandidates";

export const useGetPartyAndCandidateNumber = () => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const { refetch } = useQuery(GET_PARTY_AND_CADIDATE_NUMBER, {
    onCompleted: ({ getPartyAndCandidateNumber }) => {
      setTableData(getPartyAndCandidateNumber || []);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, []);

  return { tableData, loading, refetch };
};
